"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const u=require("./index25.js");var r=u.defineBuiltIn,f=function(e,n,t){for(var i in n)r(e,i,n[i],t);return e};exports.defineBuiltIns=f;
